import React, { useState, useEffect } from "react";
import PlusIcon from "../../../../src/assets/images/icons/plus.svg";
import arrows from '../../../assets/images/mo_icon/mo_arrow_left.svg'
import InnerPopup from "../../Modal/InnerPopup";
import MultibetPopup from "./MultibetPopup";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { useNavigate } from "react-router-dom";
import CoachMarkPopup from "../../Modal/CoachMarkPopup";

const Multibet = (props) => {
  const Navigate = useNavigate()
  const device = useSelector(state => state.CommonConfig.device_type);
  const currentStep = useSelector((state) => state.paginationData.currentStep)

  const defaultSelectList = [
    {
      limit_id: null,
      image: PlusIcon,
      item_data: {},
    },
    {
      limit_id: null,
      image: PlusIcon,
      item_data: {},
    },
    {
      limit_id: null,
      image: PlusIcon,
      item_data: {},
    },
  ];
  const [multibetCard, setMultibetCard] = useState(defaultSelectList);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const handleShowPopup = (index) => {
    setSelectedIndex(index);
    setShowPopup(true);
  };
  const handleGameSelected = (selected_room_limit, index) => {
    let tempList = [...multibetCard];
    tempList[index]['item_data'] = selected_room_limit;
    tempList[index]['limit_id'] = selected_room_limit.selected_limit.id;
    setMultibetCard(tempList);
    setShowPopup(false);
  };

  const handleClear = (index) => {
    let tempList = [...multibetCard];
    tempList.splice(index, 1);
    tempList.push({
      limit_id: null,
      image: PlusIcon,
      item_data: {},
    });
    tempList = tempList.filter(item => item.limit_id !== null).concat(tempList.filter(item => item.limit_id === null));
    setMultibetCard(tempList);
  };
  const handlePlayNowClick = () => {
    const validateData = (multibetCard) => {
      let count = 0;
      for (let i = 0; i < multibetCard.length; i++) {
        const item = multibetCard[i];
        if (item.limit_id !== null) {
          count++;
          if (count >= 2) {
            return true;
          }
        }
      }
      return false;
    }
    let tempList = [...multibetCard].filter(item => item.limit_id !== null);
    while (tempList.length < multibetCard.length) {
      tempList.push({
        limit_id: null,
        image: PlusIcon,
        item_data: {},
      });
    }
    setMultibetCard(tempList);
    if (validateData(tempList)) {
      makeAjax(url.DINGDONG_API.getGameLink).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        let url = response.data.link;
        const gameUrl = "/api/ddGame";
        const protocol = window.location.protocol;
        const domain = window.location.hostname;
        const orbit = localStorage.getItem("user_id");


        const homeUrl = response.data.home_url.replace(/\/api$/, '');
        let query_param = {
          orbit: orbit,
          type: "multibet",
          limit1: tempList[0].limit_id,
          limit2: tempList[1].limit_id,
          token: response.data.token,
          operatorid: response.data.operatorid,
          username: response.data.username,
          one_time_token: response.data.one_time_token,
          home_url: homeUrl
        };
        if (tempList[2].limit_id !== null && tempList[2].limit_id !== "") {
          query_param.limit3 = tempList[2].limit_id;
        }
        let param_string = Object.keys(query_param)
          .map(function (key) {
            return (
              encodeURIComponent(key) +
              "=" +
              encodeURIComponent(query_param[key])
            );
          })
          .join("&");
        url = url + gameUrl + "?" + param_string;
        window.open(url, "_blank");
        setMultibetCard(defaultSelectList);
      });
    } else {
      showMessage(`${props.t("select_2_or_more_game")}`, "error", "Message")
    }
  }

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // Adjust breakpoint as needed
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`card_container ${device === "Desktop" ? "desktop" : "mobile"}`} style={{
        zIndex: device === "Desktop" && currentStep === 12 ? 11 : "auto", overflow: device === "Desktop" && currentStep === 12 ? "visible" : "auto",
      }}>
        <div className="dashboard_main" style={
          currentStep === 12
            ? { overflowY: "visible", overflowX: "visible" }
            : {}
        }>
          <div >
            <div className='mo_pages_topbar'>
              <div className='back_arrow' onClick={() => Navigate("/")}>
                <img src={arrows}></img>
              </div>
            </div>
            <div className="dashboard_top_header" style={{ zIndex: currentStep === 12 ? 1 : 'auto' }}>
              <h2 className="dashboard_heading">{props.t('multi_bet_feature', { defaultValue: 'Multi Bet Feature' })}</h2>
            </div>

            <div className={`multibet_main custom-tooltip-wrapper ${(currentStep === 12) && "highlighted all-game"}`}>
              <h4 className="dashboard_heading2">{props.t('choose_game', { defaultValue: 'Choose Game' })}</h4>
              <div className={`multibet_cards `} >
                {/* multibet card desgin start */}

                {multibetCard.map((item, index) => (
                  <div className="multibet_card" key={index}>
                    <div className="multibet_card_game">
                      <div className="multibet_card_game_circle">
                        {item.limit_id != null ? (
                          <div className="multibet_card_game_icon">
                            <div className="multibet_card_game_detail">
                              <div className="multibet_detail">
                                <div className="multibet_icon">
                                  <React.Fragment>
                                    <img
                                      src={item.item_data.game_icon}
                                      alt={item.item_data.game_code}
                                    />
                                  </React.Fragment>
                                </div>
                                <p className="multibet_limit">{item.item_data.selected_limit.unit_list[0].value.toLocaleString()} - {item.item_data.selected_limit.unit_list[1].value.toLocaleString()}</p>
                                <p className="multibet_name">{props.t(item.item_data.game_code + '_label')}</p>

                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="multibet_card_game_icon" onClick={() => handleShowPopup(index)}>
                            <div
                              className="multibet_card_game_plus_icon"

                            >
                              <img src={item.image} alt={item.id} />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <button
                      className="multibet_btn"
                      onClick={() => handleShowPopup(index)}
                    >
                      {props.t('click_here')}
                    </button>
                    <button
                      disabled={item.limit_id === null}
                      className="multibet_clear_btn "
                      onClick={() => handleClear(index)}
                    >
                      {props.t('clear')}
                    </button>
                  </div>
                ))}


              </div>
              <div className="text-center">
                <button className="multibet_play_btn" onClick={handlePlayNowClick}>{props.t('play_now')}</button>
              </div>
              {currentStep == 12 && <CoachMarkPopup />}

            </div>
            {currentStep === 12 && <div className="custom-overlay" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}></div>}

          </div>
        </div>
        {currentStep === (isMobile ? 3 : 8) && <div className="custom-overlay" style={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }}
        ></div>}
        {/* {currentStep === 11 && <div className="custom-overlay multibetClass" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)"}}></div>} */}
      </div>
      {showPopup && (
        <div className="multibet_popup">
          <InnerPopup
            modalHeader={true}
            modalTitle={props.t("MB_label")}
            onCloseModal={() => setShowPopup(false)}
          >
            <MultibetPopup handleGameSelected={handleGameSelected} index={selectedIndex} multibetCard={multibetCard} />
          </InnerPopup>
        </div>
      )}
    </>
  );
}

export default withTranslation()(Multibet);